import React, { useState } from "react";
import { Modal, Form, Button } from "semantic-ui-react";

import TextareaField from "../../form/TextareaField";
import { Trans } from "react-i18next";

function CancelForm({ isOpen, onClose, onCancel }) {
  const [cancelCause, setCancelCause] = useState("");

  const cancel = () => {
    onCancel(cancelCause);

    onClose();
  };

  return (
    <Modal open={isOpen} size="small" onClose={onClose}>
      <Modal.Header as="h1" color="blue">
        <Trans i18nKey="coursePlan.details.actions.cancel" />
      </Modal.Header>
      <Modal.Content>
        <Form id="cancelForm" onSubmit={cancel}>
          <TextareaField
            label="Grund der Absage"
            value={cancelCause}
            name="cancelCause"
            rows={3}
            setFieldValue={(_, v) => setCancelCause(v)}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button type="submit" primary negative form="cancelForm">
          <Trans i18nKey="coursePlan.details.actions.cancel" />
        </Button>
        <Button floated="left" onClick={onClose}>
          <Trans i18nKey="prompt.actions.cancel" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

CancelForm.displayName = "coursePlan/details/CancelForm";

export default React.memo(CancelForm);
